// removed by extract-text-webpack-plugin
module.exports = {"CardLayout":"N0--y0iLrY9FBMyR4IVsA","FundraiserDataLayout":"wzFRMdEZWeIlmX8p2Mzt","CardConfirm":"_2hK_HidNiYOonIQlGV_oF7","ConstituentIcon":"_1vssG6cbHeQEOCaueKiZYo","ButtonLayout":"_1PzQEx3M6NY2mHjzAc0cW4"};


//////////////////
// WEBPACK FOOTER
// ./src/ConnectedComponents/FundraiserCard/index.css
// module id = 1486
// module chunks = 1